module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "overview"
  }, [_c('love-map', {
    attrs: {
      "school": _vm.schoolList
    }
  }), _vm._v(" "), _vm._t("logo"), _vm._v(" "), _vm._t("infor"), _vm._v(" "), _c('div', {
    staticClass: "data"
  }, [_c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "school"
  }, [_c('h5', [_vm._v("累计捐赠学校")]), _vm._v(" "), _c('span', {
    staticClass: "count"
  }, [_vm._v(_vm._s(_vm.formatNumber(_vm.schoolList.length)))]), _vm._v(" "), _c('span', {
    staticClass: "unit"
  }, [_vm._v("所")])]), _vm._v(" "), _c('div', {
    staticClass: "separator"
  }), _vm._v(" "), _c('div', {
    staticClass: "course"
  }, [_c('h5', [_vm._v("累计捐赠课程")]), _vm._v(" "), _c('span', {
    staticClass: "count"
  }, [_vm._v(_vm._s(_vm.formatNumber(_vm.duration2course(_vm.totalDuration))))]), _vm._v(" "), _c('span', {
    staticClass: "unit"
  }, [_vm._v("节")])])]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.totalDuration > 0),
      expression: "totalDuration > 0"
    }],
    staticClass: "tip"
  }, [_vm._v("相当于")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.formatText(_vm.duration2course(_vm.totalDuration))))])]), _vm._v(" "), _c('news', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.schoolList.length > 0),
      expression: "schoolList.length > 0"
    }],
    staticClass: "news",
    attrs: {
      "shared": _vm.shared,
      "donationObjects": _vm.donationObjects
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade-in-up",
      "appear": ""
    }
  }, [_vm._t("button", [_c('touch', {
    staticClass: "share",
    attrs: {
      "tag": "button",
      "type": "button"
    },
    on: {
      "tap": _vm.share
    }
  }, [_vm._v("邀请好友一起捐")])])], 2)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /Users/Mee/Work/lls-with-tfchina/~/vue-loader/lib/template-compiler?{"id":"data-v-7ee7d2fa","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/Users/Mee/Work/lls-with-tfchina/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Overview.vue
// module id = 209
// module chunks = 0